import { Orientation, SCALE_FACTOR } from ".";

interface PagifyProps {
  rootNodeElement: HTMLDivElement;
  headerElement: HTMLDivElement;
  orientation: Orientation;
}

export interface PageBreak {
  componentIndex: number;
}
type Pagination = {
  pageBreaks: PageBreak[];
  maxContentHeight: number;
}
// Get page breaks
const pagify = ({ rootNodeElement, headerElement, orientation }: PagifyProps): Pagination => {
  const pageHeight = orientation === "portrait" ? 11 : 8.5; // Letter paper
  // Most printers have non-printable areas.
  // Minimum safe area is considered at .25 inches on each side
  const printerSafeArea = 0.84;
  const maxSafeHeight = pageHeight - printerSafeArea;

  // Everything is in inches!
  const DPI = 96;
  const exportComponents = rootNodeElement.children;
  const headerHeight = headerElement.getBoundingClientRect().height / DPI / SCALE_FACTOR;

  const pageBreaks: PageBreak[] = [];

  if (exportComponents.length === 0 || !headerHeight) {
    return {
      maxContentHeight: maxSafeHeight,
      pageBreaks,
    };
  }

  const maxContentHeight = maxSafeHeight - headerHeight;
  const availableHeight = maxContentHeight;

  const len: number = exportComponents.length;

  let idx = 0;
  let accHeight = 0;
  while (idx < len) {
    const elem = exportComponents[idx];
    const hgt = elem.getBoundingClientRect().height / DPI / SCALE_FACTOR;
    accHeight += hgt;
    if (accHeight > availableHeight) {
      pageBreaks.push({ componentIndex: idx });
      accHeight = hgt;
    }
    idx++;
  }
  pageBreaks.push({ componentIndex: len });
  return {
      maxContentHeight: availableHeight,
      pageBreaks,
    };
};

export default pagify;
